import AmbulatoriList from "./components/AmbulatorioList.vue";
import AmbulatorioView from "./components/AmbulatorioView.vue";
import AmbulatorioEdit from "./components/AmbulatorioEdit.vue";

export default {
    AmbulatoriList, 
    AmbulatorioView,
    AmbulatorioEdit
};
